import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import T from 'i18n';
import styles from '../CaseIntelligenceVibrantPage.module.scss';

const NoAccessBanner: React.FC = () => {
  return (
    <div className={styles.noAccessBanner}>
      <LockOutlinedIcon sx={{ fontSize: 36, mb: 1, color: 'text.disabled' }} />
      <p>{T.translate('caseIntelligence.noAccess')}</p>
    </div>
  );
};

export default NoAccessBanner;
